import { Button, Typography } from "@repo/design-system";
import { CheckboxRow } from "./_parts";

interface IVirusCheckboxListProps {
  viruses: string[] | null | undefined;
  selectedViruses: string[];
  onToggle: (virusName: string) => void;
  onClear: () => void;
  className?: string;
}

export function VirusCheckboxList({
  viruses,
  selectedViruses,
  onToggle,
  onClear,
  className,
}: IVirusCheckboxListProps) {
  const entries = viruses ?? [];

  if (entries.length === 0) {
    return (
      <Typography
        variant="paragraph-m-regular"
        className="text-contentTertiary">
        No viruses available
      </Typography>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col gap-2">
      <Button
        variant="secondary"
        className="h-6 flex-shrink-0 self-start px-2 py-0 text-xs"
        isDisabled={selectedViruses.length === 0}
        onPress={onClear}>
        Clear all
      </Button>

      <div
        className={`flex min-h-0 flex-1 flex-col gap-0.5 overflow-y-auto ${className ?? ""}`}>
        {entries.map((virusName) => (
          <CheckboxRow
            key={virusName}
            label={virusName}
            isSelected={selectedViruses.includes(virusName)}
            onPress={() => onToggle(virusName)}
          />
        ))}
      </div>
    </div>
  );
}
